import { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext({});
const API = process.env.REACT_APP_BACKEND_URL;

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    fetch(`${API}/api/settings`).then(r => r.json()).then(setSettings).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
